
import React from "react";
// nodejs library that concatenates classes
import classnames from "classnames";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { toast } from 'react-toastify';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";
// core components
import AuthHeader from "components/Headers/AuthHeader";
import { registerUser } from '../../../actions/authActions';
import connect from 'redux-connect-decorator';
import { Redirect, Link } from "react-router-dom";

@connect(
  state => ({
    auth: state.auth,
    result: state.auth.result,
    errors: state.errors
  }),
  {
    registerUser
  }
)
class Register extends React.Component {
  state = {
    btnEnable: false
  };

  handleSubmit = (event, errors, { username, password, confirmpassword, fullname, rememberMe }) => {
    console.log(`handleSubmit ${username} ${password}`);
    // handleLogin(username, password, rememberMe);
    if (password !== confirmpassword) {
      toast.error("Password not match.");
      return;
    }
    
    const userData = {
      name: fullname,
      student_email: username,
      password,
      token1: 'cclmagicS1T2'
    };
    this.props.registerUser(userData);
  };

  handleCheckboxChange = e => {
    this.setState({ btnEnable: e.target.checked });
  }

  render() {
    const { auth, location, result } = this.props;
    const { from } = location.state || { from: { pathname: '/user/home', search: location.search } };
    return (
      <>
        { result && <Redirect to={'/auth/login'} /> }
        <AuthHeader
          title="Register new account!"
          lead=""
        />
        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="5" md="7">
              <Card className="bg-secondary border-0 mb-0">
                <CardHeader className="bg-transparent pb-5">
                  <div className="text-muted text-center mt-2 mb-3">
                    <small>Sign up with</small>
                  </div>
                  <div className="btn-wrapper text-center">
                    <Button
                      disabled
                      className="btn-neutral btn-icon"
                      color="default"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <span className="btn-inner--icon mr-1">
                        <img
                          alt="..."
                          src={require("assets/img/icons/facebook.png")}
                        />
                      </span>
                      <span className="btn-inner--text">Facebook</span>
                    </Button>
                    <Button
                      disabled
                      className="btn-neutral btn-icon"
                      color="default"
                      href="#pablo"
                      onClick={e => e.preventDefault()}
                    >
                      <span className="btn-inner--icon mr-1">
                        <img
                          alt="..."
                          src={require("assets/img/icons/common/google.svg")}
                        />
                      </span>
                      <span className="btn-inner--text">Google</span>
                    </Button>
                  </div>
                </CardHeader>
                <CardBody className="px-lg-5 py-lg-5">
                  <div className="text-center text-muted mb-4">
                    <small>Or sign up with credentials</small>
                  </div>
                  <AvForm role="form" onSubmit={this.handleSubmit}>
                    <FormGroup
                        className={classnames("mb-3", {
                          focused: this.state.focusedName
                        })}
                      >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-hat-3" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <AvField
                          name="fullname"
                          placeholder="Name"
                          type="text"
                          onFocus={() => this.setState({ focusedName: true })}
                          onBlur={() => this.setState({ focusedName: false })}
                          autoFocus
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames("mb-3", {
                        focused: this.state.focusedEmail
                      })}
                    >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-email-83" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <AvField
                          name="username"
                          placeholder="Email"
                          type="email"
                          onFocus={() => this.setState({ focusedEmail: true })}
                          onBlur={() => this.setState({ focusedEmail: false })}
                          className="login-input"
                          validate={{
                            required: { value: true, errorMessage: "Your email is required." },
                            minLength: { value: 5, errorMessage: "Your email is required to be at least 5 characters." },
                            maxLength: { value: 50, errorMessage: "Your email cannot be longer than 50 characters." }
                          }}
                          autoFocus
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: this.state.focusedPassword
                      })}
                    >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-lock-circle-open" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <AvField
                          name="password"
                          type="password"
                          className="login-input"
                          placeholder="Password"
                          validate={{
                            required: { value: true, errorMessage: "Your password is required." },
                            minLength: { value: 4, errorMessage: "Your password is required to be at least 4 characters." },
                            maxLength: { value: 50, errorMessage: "Your password cannot be longer than 50 characters." }
                          }}
                          onFocus={() => this.setState({ focusedPassword: true })}
                          onBlur={() => this.setState({ focusedPassword: false })}
                        />
                      </InputGroup>
                    </FormGroup>
                    <FormGroup
                      className={classnames({
                        focused: this.state.focusedPassword
                      })}
                    >
                      <InputGroup className="input-group-merge input-group-alternative">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="ni ni-lock-circle-open" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <AvField
                          name="confirmpassword"
                          type="password"
                          className="login-input"
                          placeholder="Confirm Password"
                          validate={{
                            required: { value: true, errorMessage: "Your password is required." },
                            minLength: { value: 4, errorMessage: "Your password is required to be at least 4 characters." },
                            maxLength: { value: 50, errorMessage: "Your password cannot be longer than 50 characters." }
                          }}
                          onFocus={() => this.setState({ focusedConfirmPassword: true })}
                          onBlur={() => this.setState({ focusedConfirmPassword: false })}
                        />
                      </InputGroup>
                    </FormGroup>
                    <div className="custom-control custom-checkbox mb-3">
                      <input
                        className="custom-control-input"
                        id="customCheck2"
                        type="checkbox"
                        onChange={this.handleCheckboxChange}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="customCheck2"
                      >
                        <div>By signing in, you agree to the</div>
                        <a href="/auth/term_policy" className="text-cyan" target="_blank">Terms & Conditions and Privacy Policy</a>
                      </label>
                    </div>
                    <div className="text-center">
                      <Button disabled={ !this.state.btnEnable} className="my-4" color="info" type="submit">
                        Sign up
                      </Button>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
              <Row className="mt-3">
                <Col xs="6">
                  <Link
                    className=""
                    to="/auth/reset_password"
                    >
                      <small>Forgot password?</small>
                  </Link>
                </Col>
                <Col className="text-right" xs="6">
                  <Link
                    className=""
                    to="/auth/login"
                    >
                      <small>Login</small>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default Register;
